/**
 * Transfer Configuration for Caps
 */

import { supabase } from '../../../../../supabaseClient';

export const transferCapConfig = {
  type: 'caps',
  displayName: 'Caps',
  singularName: 'Cap',
  itemIdField: 'cap_id',
  itemNameField: 'name',
  
  // Database tables
  inventoryTable: 'caps_inventory',
  itemsTable: 'caps_inventory_items',
  transactionsTable: 'caps_transactions',
  
  // Get available inventory items for a location
  getInventoryItems: async (companyId, itemId, locationId) => {
    const { data, error } = await supabase
      .from('caps_inventory_items')
      .select('*')
      .eq('company_id', companyId)
      .eq('cap_id', itemId)
      .eq('location_id', locationId)
      .eq('is_active', true)
      .gt('current_quantity', 0)
      .order('created_at', { ascending: true });
    
    if (error) throw error;
    return data || [];
  },
  
  // Execute transfer transaction
  executeTransfer: async (companyId, transferData) => {
    const { fromLocationId, toLocationId, transfers, notes } = transferData;
    
    // Process each transfer item
    for (const transfer of transfers) {
      const { itemId, lotId, quantity, lot_number, batch_number } = transfer;
      
      // Only create transaction - DB triggers will handle inventory updates
      const { error: txError } = await supabase
        .from('caps_transactions')
        .insert([{
          company_id: companyId,
          cap_id: itemId,
          transaction_type: 'transfer',
          quantity: quantity,
          from_location_id: fromLocationId,
          to_location_id: toLocationId,
          lot_number: lot_number,
          batch_number: batch_number,
          transaction_date: new Date().toISOString(),
          notes: notes || null,
          delivery_status: 'delivered'
        }]);

      if (txError) throw txError;

      // DB triggers may create inventory_items rows without is_active = true (defaults false).
      // Activate all items at the destination that have stock after the trigger runs.
      await supabase
        .from('caps_inventory_items')
        .update({ is_active: true })
        .eq('company_id', companyId)
        .eq('cap_id', itemId)
        .eq('location_id', toLocationId)
        .gt('current_quantity', 0);
    }
  }
};
